export default __webpack_public_path__ + "static/media/linkedin-icon.877e9f87.png";